import { render, staticRenderFns } from "./EventDetailsLegacyModal.vue?vue&type=template&id=7bfa4446&"
import script from "./EventDetailsLegacyModal.vue?vue&type=script&lang=ts&"
export * from "./EventDetailsLegacyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports